import {APP_INITIALIZER, InjectionToken, Provider} from '@angular/core';
import {StoreIndexedDbStorage} from '@platform/storage/infrastructure/storage-indexdb.storage';
import {Logger} from 'src/app/core/interfaces/Logger';
import {PermissionState, PermissionStore} from '../../application/stores/permission.store';
import {PERMISSION_STORE_STORAGE} from '../../domain/tokens/permission-store-storage.token';
import {PERMISSION_REPOSITORY_TOKEN} from '../../domain/tokens/permission-repository.token';
import {PERMISSION_CHECKER_TOKEN} from '../../domain/tokens/permission-checker.token';
import {WORKER_PERMISSIONS_TOKEN} from '../../domain/tokens/worker-permissions.token';
import {HttpPermissionRepositoryAdapter} from '../adapters/http-permission-repository.adapter';
import {PermissionCheckerService} from '../../application/services/permission-checker.service';
import {WorkerPermissionsAdapter} from '../adapters/worker-permissions.adapter';
import {PermissionOnDataLoadSubscriber} from '../subscribers/permission-on-data-load.subscriber';
import {PermissionOnWorkerChangedSubscriber} from '../subscribers/permission-on-worker-changed.subscriber';
import {PermissionCleanDataSubscriber} from '../subscribers/permission-clean-data.subscriber';
import {StorageSynchronizer} from '@platform/storage/application/storage.synchronizer';

export const PERMISSION_DOMAIN_SUBSCRIBERS = new InjectionToken<unknown[]>('PERMISSION_DOMAIN_SUBSCRIBERS');

export const PERMISSION_PROVIDERS: Provider[] = [
  {
    provide: PERMISSION_REPOSITORY_TOKEN,
    useClass: HttpPermissionRepositoryAdapter,
  },
  {
    provide: PERMISSION_CHECKER_TOKEN,
    useClass: PermissionCheckerService,
  },
  {
    provide: WORKER_PERMISSIONS_TOKEN,
    useClass: WorkerPermissionsAdapter,
  },
  {
    provide: PERMISSION_DOMAIN_SUBSCRIBERS,
    useClass: PermissionOnDataLoadSubscriber,
    multi: true,
  },
  {
    provide: PERMISSION_DOMAIN_SUBSCRIBERS,
    useClass: PermissionOnWorkerChangedSubscriber,
    multi: true,
  },
  {
    provide: PERMISSION_DOMAIN_SUBSCRIBERS,
    useClass: PermissionCleanDataSubscriber,
    multi: true,
  },
  {
    provide: PERMISSION_STORE_STORAGE,
    useFactory: (logger: Logger) => new StoreIndexedDbStorage<PermissionState>(logger, 'permission'),
    deps: [Logger]
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (storage: StoreIndexedDbStorage<PermissionState>, store: PermissionStore) => new StorageSynchronizer<PermissionState>(storage, store).sync(),
    deps: [PERMISSION_STORE_STORAGE, PermissionStore],
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (subscribers: unknown[]) => () => void subscribers,
    deps: [PERMISSION_DOMAIN_SUBSCRIBERS],
  },
];
